/**
 * SourceGenerator Risk Type Chip Component
 * Displays source generator risk type with appropriate color
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import {
  SourceGeneratorRiskType,
  RISK_TYPE_LABELS,
  RISK_TYPE_COLORS,
} from '../../../types/sourceGenerator';

interface SourceGeneratorRiskTypeChipProps {
  type: SourceGeneratorRiskType;
  size?: 'small' | 'medium';
}

export const SourceGeneratorRiskTypeChip: React.FC<SourceGeneratorRiskTypeChipProps> = ({
  type,
  size = 'small',
}) => {
  return (
    <Chip
      label={RISK_TYPE_LABELS[type] || type}
      size={size}
      color={RISK_TYPE_COLORS[type] || 'primary'}
      variant="outlined"
    />
  );
};

export default SourceGeneratorRiskTypeChip;
